/**
 * `/drafts/:draftId` — open ONE email draft (TASK-702).
 *
 * A `work_task` run attaches an `email_draft` artifact and parks the task for sign-off. Until
 * this route existed the review card linked to `/drafts/{id}`, which matched no route at all,
 * so every artifact — resolvable or not — landed on the app's not-found page. "Never a dead
 * link" was the ticket's own rule and the link was dead by construction.
 *
 * Thin by design: `EmailDraft` already owns the whole composer, provenance panel and
 * approve/send lifecycle. This only supplies the id.
 */
import { useParams } from 'react-router-dom';

import { EmailDraft } from '../components/canvas/widgets/EmailDraft';

export default function DraftPage() {
  const { draftId } = useParams<{ draftId: string }>();

  if (!draftId) {
    return (
      <div className="p-6 text-sm text-muted-foreground">No draft was requested.</div>
    );
  }

  return (
    <div className="mx-auto max-w-5xl p-6">
      <h1 className="mb-4 text-lg font-semibold text-foreground">Email draft</h1>
      <EmailDraft draftId={draftId} />
    </div>
  );
}
